import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { Icon, List, Loader, Popup, TextInput } from '@gravity-ui/uikit';
import { OutsideFocusHandlerContainer } from '@yandex-data-ui/common';
import { BASE_URL, INPUT_BORDER_WIDTH, MARKS_BASE_URL, SCOPES, SCOPES_INTERNAL_NET, SCOPES_WITH_CHAT, SCOPES_WITH_NPM, SUGGEST_BASE_URL } from '../../constants';
import { Goal, Key, ScopesPreset, Status } from '../../types';
import { debounce, getLocation, getSearchSiteUrl, gotoLink, initMetrika, sendMetrika as _sendMetrika, throttle } from '../../utils';
import { block } from '../../utils/cn';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { LabelFilters } from '../LabelFilters/LabelFilters';
import { ScopesList } from '../ScopesList/ScopesList';
import { StubScreen } from '../StubScreen/StubScreen';
import { StubScreenNoResults } from '../StubScreen/StubScreenNoResults';
import { AllResultsButton } from './AllResultsButton';
import { SearchListRow } from './SearchListRow';
import i18n from './i18n';
import { getDataItemPos, getInitialScope, getItemUrl, getItemsDefault, getStatResults, isDataItem, normalizeFilter, sendMarkDefault } from './utils';
import searchIcon from '../../assets/icons/search';
import './Search.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var b = block('search');
export var Search = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Search, _React$PureComponent);
  var _super = _createSuper(Search);
  function Search() {
    var _this$props$filters;
    var _this;
    _classCallCheck(this, Search);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      status: Status.IDLE,
      focused: false,
      inputFocused: false,
      scope: getInitialScope(_this.props.serviceLayer, _this.props.selectedScope) || '',
      items: [],
      text: _this.props.initialText || '',
      filter: normalizeFilter((_this$props$filters = _this.props.filters) === null || _this$props$filters === void 0 ? void 0 : _this$props$filters[getInitialScope(_this.props.serviceLayer, _this.props.selectedScope)]),
      isearchReqId: undefined
    };
    _this.throttledForceUpdate = throttle(function () {
      return _this.forceUpdate();
    }, 300);
    _this.textInputRef = /*#__PURE__*/React.createRef();
    _this.textInputOuterRef = /*#__PURE__*/React.createRef();
    _this.wrapperListRef = /*#__PURE__*/React.createRef();
    _this.allResultsBtnRef = /*#__PURE__*/React.createRef();
    _this.listRef = /*#__PURE__*/React.createRef();
    _this.latestPromise = void 0;
    _this.latestAbortController = void 0;
    _this.componentId = "".concat(new Date().getTime(), "-").concat(Math.floor(Math.random() * 1000));
    _this._getItemsDebounced = debounce(function (params) {
      return _this._getItems(params);
    }, _this.props.debounce);
    _this._getItemsTimeout = void 0;
    _this._getItems = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var _this$latestAbortCont;
        var _this$props, _this$props$symbolsTo, symbolsToStart, getItems, controller, items, error, fetched, _items$;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, _this$props$symbolsTo = _this$props.symbolsToStart, symbolsToStart = _this$props$symbolsTo === void 0 ? 0 : _this$props$symbolsTo, getItems = _this$props.getItems;
              controller = new AbortController();
              items = [];
              (_this$latestAbortCont = _this.latestAbortController) === null || _this$latestAbortCont === void 0 || _this$latestAbortCont.abort();
              _this.latestAbortController = controller;
              if (!(_this.state.text.length < symbolsToStart)) {
                _context.next = 8;
                break;
              }
              _this.setState({
                items: [],
                status: Status.IDLE,
                error: undefined
              });
              return _context.abrupt("return");
            case 8:
              fetched = getItems === null || getItems === void 0 ? void 0 : getItems(params, controller.signal);
              if (fetched instanceof Promise) {
                _this.latestPromise = fetched;
              }
              _context.prev = 10;
              _context.next = 13;
              return fetched;
            case 13:
              _context.t0 = _context.sent;
              if (_context.t0) {
                _context.next = 16;
                break;
              }
              _context.t0 = [];
            case 16:
              items = _context.t0;
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t1 = _context["catch"](10);
              error = _context.t1;
            case 22:
              if (!(fetched instanceof Promise)) {
                _context.next = 26;
                break;
              }
              if (!(fetched !== _this.latestPromise)) {
                _context.next = 25;
                break;
              }
              return _context.abrupt("return");
            case 25:
              delete _this.latestPromise;
            case 26:
              if (_this.state.text.length < symbolsToStart) {
                _this.setState({
                  items: [],
                  status: Status.IDLE,
                  error: undefined,
                  lastFetchScope: params.scope,
                  lastFetchText: params.text,
                  lastFetchFilter: params.filter,
                  isearchReqId: undefined
                });
              } else if (error) {
                _this.setState({
                  items: items,
                  status: Status.FAILED,
                  error: error,
                  lastFetchScope: params.scope,
                  lastFetchText: params.text,
                  lastFetchFilter: params.filter,
                  isearchReqId: undefined
                }, _this.onError);
              } else {
                _this.setState({
                  items: items,
                  status: Status.FINISHED,
                  lastFetchScope: params.scope,
                  lastFetchText: params.text,
                  lastFetchFilter: params.filter,
                  isearchReqId: (_items$ = items[0]) === null || _items$ === void 0 || (_items$ = _items$.meta) === null || _items$ === void 0 ? void 0 : _items$.isearchReqId
                }, _this.onItemsFetched);
              }
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[10, 19]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this._getScopes = function (preset, serviceLayer) {
      if (serviceLayer === 'isearch') {
        return SCOPES_WITH_CHAT;
      }
      if (serviceLayer === 'npm' || serviceLayer === 'isearch') {
        return SCOPES_WITH_NPM;
      }
      return preset === ScopesPreset.INTERNAL_NET ? SCOPES_INTERNAL_NET : SCOPES;
    };
    _this.onMetrikaInit = function () {
      var _getLocation;
      var data = {
        event: 'init',
        suggestUrl: _this.props.baseResultsUrl,
        href: (_getLocation = getLocation()) === null || _getLocation === void 0 ? void 0 : _getLocation.href
      };
      _this.sendMetrika(data);
    };
    _this.onInteractError = function (error) {
      var _this$props2 = _this.props,
        onInteractError = _this$props2.onInteractError,
        toaster = _this$props2.toaster;
      if (onInteractError) {
        onInteractError(error);
      } else {
        toaster === null || toaster === void 0 || toaster.add({
          name: 'ic-search_err',
          type: 'error',
          title: i18n('error_title'),
          content: (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.name)
        });
      }
      _this.onError(error);
    };
    _this.onItemsFetched = function () {
      var items = _this.state.items;
      window.requestAnimationFrame(_this.deactivateListItem);
      _this.sendMetrika({
        event: 'show',
        results: getStatResults(items.map(function (item, ind) {
          return _objectSpread(_objectSpread({}, item), {}, {
            height: _this.getItemHeight(ind)
          });
        }))
      });
    };
    _this.activateFirstResult = function () {
      var _this$state = _this.state,
        inputFocused = _this$state.inputFocused,
        items = _this$state.items;
      if (items.length && inputFocused) {
        var ind = items[0].disabled ? 1 : 0;
        _this.activateListItem(ind);
      }
    };
    _this.activateLastResult = function () {
      var _this$state2 = _this.state,
        inputFocused = _this$state2.inputFocused,
        items = _this$state2.items;
      if (items.length && inputFocused) {
        _this.activateListItem(items.length - 1);
      }
    };
    _this.activateListItem = function (itemInd) {
      var _this$listRef;
      (_this$listRef = _this.listRef) === null || _this$listRef === void 0 || (_this$listRef = _this$listRef.current) === null || _this$listRef === void 0 || _this$listRef.activateItem(itemInd);
    };
    _this.deactivateListItem = function () {
      _this.activateListItem(-1);
    };
    _this.moveCaretToTextInputEnd = function () {
      var _this$textInputRef;
      var input = (_this$textInputRef = _this.textInputRef) === null || _this$textInputRef === void 0 ? void 0 : _this$textInputRef.current;
      if (input) {
        // ставим курсор в конец текста
        input.selectionStart = input.selectionEnd = input.value.length;
      }
    };
    _this.handleClickOrFocusOutside = function () {
      _this.setState(function (state) {
        return state.focused ? {
          focused: false
        } : null;
      });
    };
    _this.onPopupClose = function () {
      _this.setState({
        focused: false
      });
    };
    _this.renderItem = function (item, _active, index) {
      var _this$props3 = _this.props,
        logoClassName = _this$props3.logoClassName,
        view = _this$props3.view;
      return /*#__PURE__*/_jsx(SearchListRow, {
        pos: index,
        item: item,
        onError: _this.onError,
        className: b('item-content', _this.props.className),
        logoClassName: logoClassName,
        onMarkClick: _this.onMarkClick,
        view: view
      });
    };
    _this.onItemClick = function (item, index, fromKeyboard) {
      var items = _this.state.items;
      if (isDataItem(item)) {
        _this.sendMetrika({
          event: 'click',
          id: item.id,
          pos: getDataItemPos(items, item),
          url: getItemUrl(item),
          type: item.layer,
          height: _this.getItemHeight(index)
        });
      }
      if (_this.props.onItemClick) {
        _this.props.onItemClick(item, index, fromKeyboard);
      } else if (fromKeyboard) {
        gotoLink(getItemUrl(item));
      }
    };
    _this.getItemHeight = function (index) {
      var _this$wrapperListRef, _list$querySelectorAl, _listItem$offsetHeigh;
      var list = (_this$wrapperListRef = _this.wrapperListRef) === null || _this$wrapperListRef === void 0 ? void 0 : _this$wrapperListRef.current;
      var listItem = list === null || list === void 0 || (_list$querySelectorAl = list.querySelectorAll('.ic-search__item')) === null || _list$querySelectorAl === void 0 ? void 0 : _list$querySelectorAl[index !== null && index !== void 0 ? index : 1];
      return (_listItem$offsetHeigh = listItem === null || listItem === void 0 ? void 0 : listItem.offsetHeight) !== null && _listItem$offsetHeigh !== void 0 ? _listItem$offsetHeigh : 0;
    };
    _this.onUpdate = function (text) {
      _this.setState(function (state) {
        return {
          text: text,
          focused: Boolean(text && !state.focused) || state.focused
        };
      }, function () {
        _this.fetchItems();
      });
    };
    _this.handleKeyUp = function (e) {
      var _e$target;
      var hotKey = _this.props.hotKey;
      var targetType = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.type;
      var isTextInput = e.target instanceof HTMLInputElement && targetType === 'text';
      var isTextArea = e.target instanceof HTMLTextAreaElement;
      if (e.key === hotKey && !(isTextInput || isTextArea)) {
        var _this$textInputRef2, _getLocation2;
        (_this$textInputRef2 = _this.textInputRef) === null || _this$textInputRef2 === void 0 || (_this$textInputRef2 = _this$textInputRef2.current) === null || _this$textInputRef2 === void 0 || _this$textInputRef2.focus();
        window.requestAnimationFrame(_this.moveCaretToTextInputEnd);
        _this.sendMetrika({
          event: 'use_focus_hotkey',
          shortcut: hotKey,
          href: (_getLocation2 = getLocation()) === null || _getLocation2 === void 0 ? void 0 : _getLocation2.href
        });
      }
    };
    _this.onInputFocus = function (event) {
      _this.setState({
        focused: true,
        inputFocused: true
      });
      var _this$props4 = _this.props,
        onInputFocus = _this$props4.onInputFocus,
        renderStyle = _this$props4.renderStyle;
      var _this$state3 = _this.state,
        lastFetchScope = _this$state3.lastFetchScope,
        lastFetchText = _this$state3.lastFetchText,
        lastFetchFilter = _this$state3.lastFetchFilter,
        scope = _this$state3.scope,
        text = _this$state3.text,
        filter = _this$state3.filter;
      if (renderStyle === 'popup' && (lastFetchScope !== scope || lastFetchText !== text || lastFetchFilter !== filter)) {
        _this.fetchItems();
      }
      if (onInputFocus) {
        onInputFocus(event);
      }
    };
    _this.onInputBlur = function (event) {
      _this.setState({
        inputFocused: false
      });
      var onInputBlur = _this.props.onInputBlur;
      if (onInputBlur) {
        onInputBlur(event);
      }
    };
    _this.onScopeClick = function (scope) {
      var filters = _this.props.filters;
      _this.setState({
        focused: true,
        scope: scope,
        filter: normalizeFilter(filters === null || filters === void 0 ? void 0 : filters[scope])
      }, function () {
        _this.fetchItems();
      });
    };
    _this.onInputKeyDown = function (event) {
      var _this$listRef2, _items$2, _this$allResultsBtnRe;
      var _this$props5 = _this.props,
        baseUrl = _this$props5.baseUrl,
        allResultsLinks = _this$props5.allResultsLinks,
        renderStyle = _this$props5.renderStyle;
      var _this$state4 = _this.state,
        text = _this$state4.text,
        scope = _this$state4.scope,
        items = _this$state4.items,
        filter = _this$state4.filter;
      var list = (_this$listRef2 = _this.listRef) === null || _this$listRef2 === void 0 ? void 0 : _this$listRef2.current;
      var listActiveItem = list === null || list === void 0 ? void 0 : list.getActiveItem();
      if (event.key === Key.ENTER && (!list || typeof listActiveItem !== 'number' || listActiveItem === -1)) {
        if (_this.props.onInputEnterKeyDown) {
          if (renderStyle === 'popup') {
            _this.onPopupClose();
          }
          _this.props.onInputEnterKeyDown(text, scope, event);
        } else {
          var _allResultsLinks$scop, _allResultsLinks$scop2;
          var url = (_allResultsLinks$scop = allResultsLinks === null || allResultsLinks === void 0 || (_allResultsLinks$scop2 = allResultsLinks[scope]) === null || _allResultsLinks$scop2 === void 0 ? void 0 : _allResultsLinks$scop2.url) !== null && _allResultsLinks$scop !== void 0 ? _allResultsLinks$scop : getSearchSiteUrl({
            text: text,
            scope: scope,
            filter: filter,
            baseUrl: baseUrl
          });
          _this.sendMetrika({
            event: 'goto_all',
            type: 'enter',
            url: url
          });
          gotoLink(url);
        }
      } else if ((event.key === Key.ARROW_DOWN && listActiveItem === items.length - 1 || event.key === Key.ARROW_UP && (listActiveItem === 0 || (_items$2 = items[0]) !== null && _items$2 !== void 0 && _items$2.disabled && listActiveItem === 1)) && (_this$allResultsBtnRe = _this.allResultsBtnRef) !== null && _this$allResultsBtnRe !== void 0 && _this$allResultsBtnRe.current) {
        _this.allResultsBtnRef.current.focus();
        _this.deactivateListItem();
      } else if (event.key === Key.HOME || event.key === Key.END) {
        return;
      } else if (list) {
        list.onKeyDown(event);
      }
    };
    _this.onAllResultsKeyDown = function (event) {
      var _this$textInputRef3;
      var items = _this.state.items;
      var input = (_this$textInputRef3 = _this.textInputRef) === null || _this$textInputRef3 === void 0 ? void 0 : _this$textInputRef3.current;
      if (items.length && (event.key === Key.ARROW_UP || event.key === Key.ARROW_DOWN)) {
        input === null || input === void 0 || input.focus();
        window.requestAnimationFrame(event.key === Key.ARROW_UP ? _this.activateLastResult : _this.activateFirstResult);
        if (event.key === Key.ARROW_UP) {
          window.requestAnimationFrame(_this.moveCaretToTextInputEnd);
        }
      }
    };
    _this.onAllResultsClick = function (event) {
      _this.sendMetrika({
        event: 'goto_all',
        type: 'click',
        url: event.currentTarget.href
      });
    };
    _this.onScopesListKeyDown = function (event) {
      var _this$textInputRef4;
      var items = _this.state.items;
      var input = (_this$textInputRef4 = _this.textInputRef) === null || _this$textInputRef4 === void 0 ? void 0 : _this$textInputRef4.current;
      if (event.key === Key.ARROW_UP) {
        input === null || input === void 0 || input.focus();
        window.requestAnimationFrame(_this.moveCaretToTextInputEnd);
      } else if (items.length && event.key === Key.ARROW_DOWN) {
        input === null || input === void 0 || input.focus();
        window.requestAnimationFrame(_this.activateFirstResult);
      }
    };
    _this.onLabelFiltersItemRemove = function (name) {
      _this.setState(function (state) {
        var newFilter = _objectSpread({}, state.filter);
        newFilter[name] = _objectSpread({}, newFilter[name]);
        newFilter[name].active = false;
        return {
          filter: newFilter
        };
      }, _this.fetchItems);
      _this.sendMetrika({
        event: 'filter_remove',
        name: name
      });
    };
    _this.onLabelFiltersItemAdd = function (name) {
      _this.setState(function (state) {
        var newFilter = _objectSpread({}, state.filter);
        newFilter[name] = _objectSpread({}, newFilter[name]);
        newFilter[name].active = true;
        return {
          filter: newFilter
        };
      }, _this.fetchItems);
      _this.sendMetrika({
        event: 'filter_add',
        name: name
      });
    };
    _this.onMarkClick = function (mark, item) {
      var _this$state5 = _this.state,
        items = _this$state5.items,
        text = _this$state5.text,
        scope = _this$state5.scope,
        isearchReqId = _this$state5.isearchReqId;
      var _this$props6 = _this.props,
        sendMark = _this$props6.sendMark,
        onMarkClick = _this$props6.onMarkClick,
        baseMarksUrl = _this$props6.baseMarksUrl;
      var pos = getDataItemPos(items, item);
      var type = item.layer;
      _this.sendMetrika({
        event: 'mark',
        target: mark,
        id: item.id,
        pos: pos,
        url: getItemUrl(item),
        type: type
      });
      if (sendMark) {
        var _sendMark, _getLocation3;
        (_sendMark = sendMark({
          score: mark,
          url: item.url,
          href: (_getLocation3 = getLocation()) === null || _getLocation3 === void 0 ? void 0 : _getLocation3.href,
          text: text,
          scope: scope,
          position: pos,
          layer: type,
          mode: 'suggest',
          baseMarksUrl: baseMarksUrl,
          isearchReqId: isearchReqId
        })) === null || _sendMark === void 0 || _sendMark["catch"](_this.onInteractError);
      }
      if (onMarkClick) {
        onMarkClick(mark, item);
      }
    };
    return _this;
  }
  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var text = this.state.text;
      var _this$props7 = this.props,
        renderStyle = _this$props7.renderStyle,
        metrika = _this$props7.metrika,
        useHotKey = _this$props7.useHotKey,
        view = _this$props7.view;
      if (renderStyle === 'popup') {
        window.addEventListener('resize', this.throttledForceUpdate);
      }
      if ((metrika === null || metrika === void 0 ? void 0 : metrika.enabled) !== false) {
        initMetrika(this.onMetrikaInit);
      }
      if (text) {
        this.fetchItems({
          immediate: true
        });
      }
      if (view !== 'mobile' && useHotKey) {
        document.addEventListener('keyup', this.handleKeyUp);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var _this$props8 = this.props,
        filters = _this$props8.filters,
        selectedScope = _this$props8.selectedScope,
        renderStyle = _this$props8.renderStyle,
        serviceLayer = _this$props8.serviceLayer,
        initialText = _this$props8.initialText;
      if (initialText !== prevProps.initialText) {
        this.setState({
          text: initialText || ''
        }, function () {
          if (renderStyle === 'inline') {
            _this2.fetchItems();
          }
        });
      }
      if (serviceLayer !== 'isearch') {
        return;
      }
      if (selectedScope && (selectedScope !== prevProps.selectedScope || filters !== prevProps.filters)) {
        this.setState({
          scope: selectedScope,
          filter: normalizeFilter(filters === null || filters === void 0 ? void 0 : filters[selectedScope])
        }, function () {
          if (renderStyle === 'inline') {
            _this2.fetchItems();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$latestAbortCont2;
      window.removeEventListener('resize', this.throttledForceUpdate);
      document.removeEventListener('keyup', this.handleKeyUp);
      (_this$latestAbortCont2 = this.latestAbortController) === null || _this$latestAbortCont2 === void 0 || _this$latestAbortCont2.abort();
      if (this._getItemsTimeout) {
        clearTimeout(this._getItemsTimeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$textInputOuterR;
      var _this$props9 = this.props,
        size = _this$props9.size,
        className = _this$props9.className,
        placeholder = _this$props9.placeholder,
        inputClassName = _this$props9.inputClassName,
        queryClassName = _this$props9.queryClassName,
        scopesClassName = _this$props9.scopesClassName,
        popupClassName = _this$props9.popupClassName,
        popupContentClassName = _this$props9.popupContentClassName,
        popupOthersClassName = _this$props9.popupOthersClassName,
        popupPlacement = _this$props9.popupPlacement,
        autoFocus = _this$props9.autoFocus,
        renderStyle = _this$props9.renderStyle,
        view = _this$props9.view,
        serviceLayer = _this$props9.serviceLayer,
        scopesInitialCountVisible = _this$props9.scopesInitialCountVisible,
        scopesPreset = _this$props9.scopesPreset,
        showScopesList = _this$props9.showScopesList,
        showFilters = _this$props9.showFilters,
        showSearchIcon = _this$props9.showSearchIcon,
        onChange = _this$props9.onChange;
      var _this$state6 = this.state,
        focused = _this$state6.focused,
        text = _this$state6.text,
        scope = _this$state6.scope,
        filter = _this$state6.filter;
      var content = this.getContent();
      var isInline = renderStyle === 'inline';
      var isMobileView = view === 'mobile';
      var scopes = this._getScopes(scopesPreset, serviceLayer);
      var input = /*#__PURE__*/_jsxs("div", {
        className: b('query', {
          'with-icon': showSearchIcon,
          size: size
        }, queryClassName),
        children: [showSearchIcon && /*#__PURE__*/_jsx("span", {
          className: b('input-icon'),
          role: "img",
          "aria-label": "Search icon",
          children: /*#__PURE__*/_jsx(Icon, {
            data: searchIcon,
            size: 14
          })
        }), /*#__PURE__*/_jsx(TextInput, {
          size: size,
          value: text,
          placeholder: placeholder || i18n('placeholder'),
          autoFocus: autoFocus,
          controlRef: this.textInputRef,
          onUpdate: this.onUpdate,
          onFocus: this.onInputFocus,
          onBlur: this.onInputBlur,
          onKeyDown: this.onInputKeyDown,
          className: b(null, inputClassName),
          onChange: onChange,
          hasClear: true,
          controlProps: {
            role: 'searchbox'
          },
          ref: this.textInputOuterRef
        })]
      });

      // TODO(new base component): allow showScopesList for base component and hide this prop for isearch instance
      var scopesList = !['isearch', 'doc', 'stackoverflow', 'npm', 'calendar', 'atushka'].includes(serviceLayer !== null && serviceLayer !== void 0 ? serviceLayer : '') || showScopesList ? /*#__PURE__*/_jsx(ScopesList, {
        scopes: scopes,
        selectedScope: scope,
        initialCountVisibleElements: scopesInitialCountVisible,
        onScopeClick: this.onScopeClick,
        onKeyDown: this.onScopesListKeyDown,
        className: b('scopes', scopesClassName),
        popupClassName: popupOthersClassName
      }) : null;
      var labelFilters = filter && showFilters && /*#__PURE__*/_jsx(LabelFilters, {
        filter: filter,
        onItemRemove: this.onLabelFiltersItemRemove,
        onItemAdd: this.onLabelFiltersItemAdd,
        className: b('label-filters')
      });
      return /*#__PURE__*/_jsxs(OutsideFocusHandlerContainer, {
        as: "div",
        role: "search",
        className: b({
          inline: isInline,
          mobile: isMobileView
        }, className),
        enable: focused,
        onFocusOutside: this.handleClickOrFocusOutside,
        children: [input, isInline ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [scopesList, labelFilters]
        }) : null, content && (isInline ? /*#__PURE__*/_jsx(_Fragment, {
          children: content
        }) : /*#__PURE__*/_jsxs(Popup, {
          open: content && this.state.focused,
          className: b(null, popupClassName),
          contentClassName: b('popup-content', popupContentClassName),
          style: (_this$textInputOuterR = this.textInputOuterRef) !== null && _this$textInputOuterR !== void 0 && _this$textInputOuterR.current ? {
            width: this.textInputOuterRef.current.offsetWidth - 2 * INPUT_BORDER_WIDTH
          } : {},
          anchorRef: this.textInputRef,
          placement: popupPlacement,
          onOutsideClick: this.handleClickOrFocusOutside,
          onClose: this.onPopupClose,
          children: [scopesList, labelFilters, content]
        }))]
      });
    }
  }, {
    key: "fetchItems",
    value: function fetchItems(options) {
      var _this$state7 = this.state,
        text = _this$state7.text,
        scope = _this$state7.scope,
        filter = _this$state7.filter;
      var _this$props10 = this.props,
        baseResultsUrl = _this$props10.baseResultsUrl,
        serviceLayer = _this$props10.serviceLayer,
        _this$props10$symbols = _this$props10.symbolsToStart,
        symbolsToStart = _this$props10$symbols === void 0 ? 0 : _this$props10$symbols;
      var params = {
        text: text,
        scope: scope,
        filter: filter,
        baseResultsUrl: baseResultsUrl,
        serviceLayer: serviceLayer
      };
      if (this.state.text.length < symbolsToStart || !this.state.text.trim()) {
        this.setState({
          items: [],
          status: Status.IDLE,
          error: undefined,
          lastFetchText: text
        });
        if (this._getItemsTimeout) {
          clearTimeout(this._getItemsTimeout);
        }
      } else {
        this.setState({
          status: Status.LOADING,
          error: undefined
        });
        if (options !== null && options !== void 0 && options.immediate) {
          this._getItems(params);
        } else {
          this._getItemsTimeout = this._getItemsDebounced(params);
        }
      }
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var _this$props11 = this.props,
        baseUrl = _this$props11.baseUrl,
        allResultsLinks = _this$props11.allResultsLinks,
        showStubStart = _this$props11.showStubStart,
        stubStartProps = _this$props11.stubStartProps,
        stubNoResultsProps = _this$props11.stubNoResultsProps,
        itemClassName = _this$props11.itemClassName,
        showAllResultsLink = _this$props11.showAllResultsLink,
        serviceLayer = _this$props11.serviceLayer;
      var _this$state8 = this.state,
        status = _this$state8.status,
        items = _this$state8.items,
        text = _this$state8.text,
        scope = _this$state8.scope,
        filter = _this$state8.filter,
        error = _this$state8.error;
      if (status === Status.IDLE) {
        return showStubStart ? /*#__PURE__*/_jsx(StubScreen, _objectSpread({
          message: i18n('enter_search_query'),
          linkHref: getSearchSiteUrl({
            text: text,
            scope: scope,
            filter: filter,
            baseUrl: baseUrl
          })
        }, stubStartProps)) : null;
      }
      if (status === Status.LOADING) {
        return /*#__PURE__*/_jsx("div", {
          className: b('loader'),
          children: /*#__PURE__*/_jsx(Loader, {})
        });
      }
      if (status === Status.FINISHED) {
        var allResultsBtn = showAllResultsLink || serviceLayer !== 'isearch' ? /*#__PURE__*/_jsx(AllResultsButton, {
          allResultsLinks: allResultsLinks,
          scope: scope,
          text: text,
          filter: filter,
          baseUrl: baseUrl,
          className: b('all-results'),
          buttonRef: this.allResultsBtnRef,
          onKeyDown: this.onAllResultsKeyDown,
          onClick: this.onAllResultsClick
        }) : null;
        if (items.length) {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: b('list'),
              "data-testid": "results",
              ref: this.wrapperListRef,
              children: /*#__PURE__*/_jsx(List, {
                filterable: false,
                items: items,
                renderItem: this.renderItem,
                itemClassName: b('item', itemClassName),
                onItemClick: this.onItemClick,
                virtualized: false,
                ref: this.listRef
              })
            }), allResultsBtn]
          });
        } else {
          return /*#__PURE__*/_jsx(StubScreenNoResults, _objectSpread({
            searchText: text,
            linkHref: getSearchSiteUrl({
              text: text,
              scope: scope,
              filter: filter,
              baseUrl: baseUrl
            })
          }, stubNoResultsProps));
        }
      }
      if (status === Status.FAILED) {
        return /*#__PURE__*/_jsx(ErrorMessage, {
          message: error === null || error === void 0 ? void 0 : error.message
        });
      }
      return null;
    }
  }, {
    key: "sendMetrika",
    value: function sendMetrika(extraData) {
      var isearchReqId = this.state.isearchReqId;
      var _this$props$metrika = this.props.metrika,
        _this$props$metrika2 = _this$props$metrika === void 0 ? {} : _this$props$metrika,
        params = _this$props$metrika2.params,
        enabled = _this$props$metrika2.enabled;
      if (enabled === false) {
        return;
      }
      var _this$state9 = this.state,
        text = _this$state9.text,
        scope = _this$state9.scope,
        filter = _this$state9.filter;
      var data = _objectSpread({
        reqid: params === null || params === void 0 ? void 0 : params.reqid,
        intrasearch_reqid: isearchReqId,
        env: params === null || params === void 0 ? void 0 : params.env,
        text: text,
        scope: scope,
        filter: filter,
        componentId: this.componentId,
        version: 2
      }, extraData);
      _sendMetrika(Goal.INTRASEARCH_SUGGEST_METRIKA_AB, data);
    }
  }, {
    key: "onError",
    value: function onError(error) {
      var onError = this.props.onError;
      var err = error || this.state.error;
      console.error('Search: ', err);
      if (err && onError) {
        onError(err);
      }
    }
  }]);
  return Search;
}(React.PureComponent);
Search.defaultProps = {
  size: 'm',
  debounce: 300,
  renderStyle: 'inline',
  baseResultsUrl: SUGGEST_BASE_URL,
  baseMarksUrl: MARKS_BASE_URL,
  baseUrl: BASE_URL,
  getItems: getItemsDefault,
  sendMark: sendMarkDefault,
  serviceLayer: '',
  symbolsToStart: 2,
  view: 'normal',
  showStubStart: true,
  showScopesList: true,
  showFilters: true,
  showAllResultsLink: true,
  useHotKey: false,
  hotKey: '/'
};
// #sourceMappingURL=Search.js.map